import {Component, OnInit} from '@angular/core';
import {BusinessDirectoryService} from '../api/business-directory.service';
import {BusinessDirectory} from '../models/business-directory';
import {ChapterApiService} from '../api/chapter-api.service';

/** A short guide for members who want to start a business, with live links into the directory's mentors and board. */
@Component({
    selector: 'app-biz-start-up',
    templateUrl: './biz-start-up.component.html',
    styleUrl: './biz-start-up.component.css'
})
export class BizStartUpComponent implements OnInit {
    loggedIn = sessionStorage.getItem('username') !== null;
    isMember = !!JSON.parse(sessionStorage.getItem('rolesPermission') || '{}')?.BUSINESS?.includes('CREATE');

    mentors: BusinessDirectory[] = [];
    chapterNames = new Map<string, string>();

    readonly checklist = [
        'Write down the problem you solve and who pays for it.',
        'Talk to five people who would be your customers before you spend money.',
        'Check licences, permits and insurance for your state and city.',
        'Pick a business structure (LLC, S-corp or sole proprietor) with an accountant.',
        'Open a separate business bank account and keep your books from day one.',
        'Set up a simple website or listing so people can find you and contact you.',
        'Ask a member who runs a similar business for thirty minutes of their time.',
    ];

    constructor(private bizService: BusinessDirectoryService, private chapterApi: ChapterApiService) {
    }

    ngOnInit(): void {
        this.chapterApi.getData().subscribe({
            next: (list: any[]) => (list || []).forEach(c => this.chapterNames.set(c.id, c.name)),
            error: err => console.error('Failed to load chapters', err)
        });
        this.bizService.search({mentor: true, sort: 'popular', size: 3}).subscribe({
            next: page => this.mentors = page.items,
            error: err => console.error('Failed to load mentors', err)
        });
    }

    chapterName(biz: BusinessDirectory): string {
        return biz.ownerChapterId ? (this.chapterNames.get(biz.ownerChapterId) || '') : '';
    }
}
